import React from "react";
import { Navbar, Container } from "reactstrap";
import "./NurseBottom.css"; // 추가: CSS 파일을 가져옵니다.

const CustomButton = ({ text, isActive, onClick }) => {
  const buttonClassName = `navbar-toggler button-width custom-button ${isActive ? "active" : ""}`;

  return (
    <button className={buttonClassName} type="button" onClick={onClick}>
      {text}
    </button>
  );
};

const CustomNavbar = ({ activeItem, onMenuClick }) => {
  return (
    <Navbar className="navbar-vertical fixed-bottom navbar-light bg-white" expand="md" id="sidenav-main">
      <Container>
        <CustomButton text="환자목록" isActive={activeItem === "환자목록"} onClick={() => onMenuClick("환자목록")} />
        <CustomButton text="정보입력" isActive={activeItem === "정보입력"} onClick={() => onMenuClick("정보입력")} />
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
